import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { getAdobeECID } from '../../../../../app/shared/utils/adobe-ecid';

@Injectable()
export class AdobeECIDInterceptor implements HttpInterceptor {
  private ecidEndpoints = [
    'submitCapsLead',
    'submit-caps-lead',
    'reSubmitLongFormApplication',
    're-submit-long-form',
    'submitLongFormApplication',
    'submit-long-form',
    'createAbandonEmail',
    'create-abandon-email',
  ];

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.method === 'POST' && this.shouldAddECID(req.url)) {
      return getAdobeECID().pipe(
        take(1),
        switchMap((ecid) => {
          const ecidReq = req.clone({
            setHeaders: {
              'x-ecid': ecid || '',
            },
          });
          return next.handle(ecidReq);
        })
      );
    }
    return next.handle(req);
  }

  private shouldAddECID(url: string): boolean {
    return this.ecidEndpoints.some((endpoint) => url.includes(endpoint));
  }
}
